<template>
  <div>
    <el-dialog
      width="900px"
      class="ap-create"
      :visible.sync="dialogShow"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      append-to-body
      @close="onDialogClose"
      :destroy-on-close="true"
      :show-close="!loading"
    >
      <div slot="title" class="flex align-items-center">
        <span class="ap-title" style="display: inline-block;height: 30px;line-height: 30px;font-size: 21px;">新建接入点</span>
        <div v-if="!is_success" class="flex align-items-center">
          <span style="display: inline-block;" class="mr">
            <UploadExcelComponent :btnDesc="'批量导入'" plain :on-success="handleSuccess" :before-upload="beforeUpload" />
          </span>
          <span class="text-muted flex align-items-center">
            导入格式请参考
            <el-link type="primary" :underline="false" :href="dtuTempleteUrl" style="height: 16px;">模板</el-link>
          </span>
        </div>
      </div>
      <div v-if="!is_success" v-loading="loading">
        <div class="quota-remain-card flex align-items-center justify-content-space-between">
          <div style="font-size: 18px" class="text-success">
            新建接入点预充时长
            <el-select v-model="precharge_month" style="width: 80px;" @change="calculateQuota()">
              <el-option v-for="item in selectOptions" :key="item.precharge_month" :label="item.label" :value="item.precharge_month"></el-option>
            </el-select>，剩余配额
            <span :class="quota_remain > 0 ? 'text-black' : 'text-danger'">{{ quota_remain }}</span> 个
          </div>
          <!-- <div class="operate-btns">
            <el-button size="medium" type="primary" @click="toQuotaBuy">购买</el-button>
          </div> -->
        </div>
        <div class="apform">
          <el-form ref="newApForm" :model="newApData" :rules="rules">
            <el-form-item prop="binds">
              <el-table ref="bindTable" :data="newApData.binds" :show-header="false" :row-class-name="tableRowClassName" tooltip-effect="dark" style="border-top: 1px solid #eee;">
                <el-table-column type="index" width="50" />
                <el-table-column min-width="180">
                  <template slot-scope="scope">
                    <el-form-item :prop="'binds[' + scope.$index + '].simid'" :rules="rules.simid">
                      <el-input :ref="'simidInput' + scope.$index" v-model="scope.row.simid" clearable placeholder="编号，由10~20位字母或数字组成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="180">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.equip_name" clearable placeholder="名称（选填）" />
                  </template>
                </el-table-column>
                <el-table-column width="80" align="right">
                  <div slot-scope="scope" style="height: 36px;" class="flex align-items-center justify-content-space-around">
                    <el-tooltip effect="dark" content="随机生成编号" placement="top">
                      <span class="iconfont icon-random-forest" style="color: #606266;font-size: 16px;" @click="randomCreate(scope.row, scope.$index)" />
                    </el-tooltip>
                    <span
                      v-if="newApData.binds.length > 1"
                      class="iconfont icon-circle-error"
                      style="color: #606266;font-size: 16px;"
                      @click="remove(scope.row)"
                    />
                  </div>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
          <div class="flex align-items-center justify-content-space-between">
            <div class="text-success mt flex align-items-center add-rows">
              <div class="flex align-items-center" style="cursor: pointer;" @click="add">
                <i class="iconfont icon-add mr-xs" style="color: #07c160;font-size: 18px;"></i>
                <span>新增</span>
              </div>
              <el-input-number size="small" controls-position="right" v-model="bindNum" style="margin: 0 10px;" :min="1" :max="100"></el-input-number>行
            </div>
            <div class="mt flex align-items-center all-random" @click="randomCreateAll()">
              <span class="iconfont icon-random-forest" style="color: #606266;font-size: 16px;" />
              <span class="ml-xs">全部随机</span>
            </div>
          </div>
          <div class="text-danger mt" v-if="newApData.binds.length > quota_remain">新建接入点数量已超出配额</div>
        </div>
      </div>
      <div v-else class="flex-center" style="height: 400px;">
        <div class="text-center mt">
          <i class="iconfont icon-success" style="font-size: 150px;color: #07c160;" />
          <div class="mt-lg" style="font-size: 18px;">{{ relationship.length }}个接入点创建成功！</div>
        </div>
      </div>
      <div slot="footer" class="text-center mb">
        <el-button class="extend" :disabled="loading" @click="onDialogClose">{{ !is_success ? '取消' : '关闭' }}</el-button>
        <el-button v-if="!is_success" class="extend" type="primary" @click="submit" :loading="loading">提交</el-button>
      </div>
    </el-dialog>
    <!-- <quota-buy v-if="quotaBuyShow" :show.sync="quotaBuyShow" @change="calculateQuota"/> -->
  </div>
</template>

<script>
import {
  calculateRemainApi,
  randomSimidApi,
  apCreateApi,
  bathRandomSimidApi,
} from "@/api/ap/apApi";
import UploadExcelComponent from "@/components/UploadExcel/index.vue";

export default {
  components: {
    UploadExcelComponent,
    // QuotaBuy: () => import("./QuotaBuy.vue"),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    month: {
      type: Number,
      default: 12,
    },
  },
  data() {
    let validateName = (rule, value, callback) => {
      // 检验逻辑，这里简单示例为是否与其他行重复
      const isRepeat = this.newApData.binds.filter((item) => {
        return item.simid === value;
      });

      isRepeat.length > 1 ? callback(new Error('编号不可重复')) : callback();
    };
    return {
      bindNum: 1,
      newApData: {
        binds: [
          {
            simid: "",
            equip_name: "",
          },
        ],
      },

      rules: {
        simid: [
          { required: true, message: "", trigger: "blur" },
          {
            min: 10,
            max: 20,
            message: "",
            trigger: "blur",
          },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "",
            trigger: "blur",
          },
          { validator: validateName, trigger: 'blur' },
        ],
      },
      loading: false,

      selectOptions: [
        {
          precharge_month: 12,
          label: "1年",
        },
        {
          precharge_month: 24,
          label: "2年",
        },
        {
          precharge_month: 36,
          label: "3年",
        },
        {
          precharge_month: 48,
          label: "4年",
        },
        {
          precharge_month: 60,
          label: "5年",
        },
        {
          precharge_month: 72,
          label: "6年",
        },
      ],
      quota_remain: 1,
      precharge_month: 12,
      dtuTempleteUrl:
        "https://api.frippler.com/attachment/docus/global/ap_create_template.xlsx",
      // quotaBuyShow: false,

      is_success: false, // 是否创建成功
      relationship: [],
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },

  created() {
    this.precharge_month = this.month
    this.calculateQuota();
  },

  methods: {
    calculateQuota(val) {
      if(val && val.refresh) {
        this.$emit("success");
      }
      calculateRemainApi({ precharge_month: this.precharge_month }).then(
        (res) => {
          if (!res.errno) {
            this.quota_remain = res.data.quota_remain;

            if (this.newApData.binds.length > 0) {
              this.newApData.binds = this.newApData.binds.filter(
                (item) => item.simid != ""
              );
              if (this.newApData.binds.length == 0) {
                this.newApData.binds = [
                  {
                    simid: "",
                    equip_name: "",
                  },
                ];
              }
            } else {
              this.newApData.binds = [
                {
                  simid: "",
                  equip_name: "",
                },
              ];
            }
          }
        }
      );
    },
    add() {
      this.bindNum = parseInt(this.bindNum);
      // if (this.newApData.binds.length + this.bindNum > this.quota_remain) {
      //   this.$message.error("配额数量不足");
      //   return;
      // }
      if (this.bindNum + this.newApData.binds.length > 100) {
        this.$message.error("最多添加100行");
        return;
      }
      if (this.bindNum) {
        for (var i = 0; i < this.bindNum; i++) {
          this.newApData.binds.push({
            simid: "",
            equip_name: "",
          });
        }
      }
    },
    randomCreate(row, index) {
      randomSimidApi().then((res) => {
        if (!res.errno) {
          row.simid = res.data.simid;
          this.$refs[`simidInput${index}`].focus();
        }
      });
    },
    randomCreateAll() {
      const length = this.newApData.binds.length;
      bathRandomSimidApi({ num: length }).then(res => {
        if (!res.errno) {
          this.newApData.binds.map((item,index) => {
            item.simid = res.data.simids[index];
            return item;
          })
          this.clearValidation();
        } else {
          this.$message.error(res.message);
        }
      })
    },

    clearValidation() {
      this.$refs.newApForm.clearValidate();
    },
    remove(row) {
      if (this.newApData.binds.length > 1) {
        this.newApData.binds.splice(this.newApData.binds.indexOf(row), 1);
        this.clearValidation();
      }
    },

    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning",
      });
      return false;
    },

    handleSuccess({ results, header }) {
      results.splice(0,2);
      if (header.indexOf("编号*") < 0) {
        this.$message.error("'编号'表头错误");
        return;
      }
      const _this = this;
      this.newApData.binds = this.newApData.binds.filter((item) => item.simid);
      const length = this.newApData.binds.length;
      results.map((item) => {
        _this.newApData.binds.push({
          simid: item['编号*'] ? item["编号*"] + '' : '',
          equip_name: item['名称（选填）'] ? item['名称（选填）'] + '' : '',
        });
        _this.newApData.binds = _this.deduplicate(_this.newApData.binds)
      });
      if (this.newApData.binds.length > length) {
        this.$message.success(`成功导入${this.newApData.binds.length - length}条数据`);
      }
    },

    deduplicate(arr) {
      let uniqueArr = arr.reduce((prev, cur) => {
      const found = prev.find(item => item.simid === cur.simid);
        if (!found) {
          prev.push(cur);
        }
        return prev;
      }, []);
      return uniqueArr;
    },

    // toQuotaBuy() {
    //   this.quotaBuyShow = true;
    // },

    resetData() {
      this.newApData.binds = [
        {
          simid: "",
          equip_name: "",
        },
      ];
      this.is_success = false;
    },

    onDialogClose() {
      if (this.loading) return;
      this.resetData();
      this.$emit("success");
      this.$emit("update:show", false);
    },
    submit() {
      if(this.quota_remain <= 0 || this.newApData.binds.length > this.quota_remain) {
        this.$message.error("配额不足，请购买配额")
        return
      }
      this.$refs.newApForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const relationship = this.newApData.binds
          this.relationship = relationship
          const params = {
            relationship,
            precharge_month: this.precharge_month,
          };

          apCreateApi(params).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.is_success = true;
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex + 1 > this.quota_remain) {
        return "danger-row";
      }
      return "";
    },
  },
};
</script>


<style lang="scss">
.ap-create {
  .el-dialog {
    min-height: 680px;
  }
  .el-dialog__header {
    height: 65px;
  }
  .el-dialog__body {
    padding: 20px 0px;
    min-height: 530px;
    margin: 0 50px;
  }
  .iccid-select {
    width: 100%;
  }
  .add-rows {
    .el-input--medium .el-input__inner {
      text-align: center;
    }
  }
  .all-random {
    &:hover {
      cursor: pointer;
      color: #07c160;
      .icon-random-forest {
        color: #07c160 !important;
      }
    }
  }
  .el-table .danger-row {
    background: #fad9d9;
  }
}
</style>
<style lang="scss" scoped>
.ap-create {
  .quota-remain-card {
    width: 800px;
    height: 80px;
    border-radius: 6px;
    background-color: rgba(238, 240, 245, 1);
    text-align: center;
    margin: 0 auto;
    padding: 0 20px;
    margin-bottom: 30px;
  }
  .icon-circle-error,
  .icon-random-forest {
    &:hover {
      color: #07c160 !important;
      cursor: pointer;
    }
  }
}
</style>